/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import CenterLayout, { CenterLayoutProps } from './CenterLayout'
import { Outlet } from 'react-router-dom'

export type ErrorLayoutProps = CenterLayoutProps

function ErrorLayout (props: ErrorLayoutProps) {
  const { children, ...others } = props
  return (
    <CenterLayout className="ErrorLayout" {...others}>
      <Outlet />
      {children}
    </CenterLayout>
  )
}

export default ErrorLayout
